import { render, staticRenderFns } from "./EditSafetyForm.vue?vue&type=template&id=bef05174&scoped=true"
import script from "./EditSafetyForm.vue?vue&type=script&lang=js"
export * from "./EditSafetyForm.vue?vue&type=script&lang=js"
import style0 from "./EditSafetyForm.vue?vue&type=style&index=0&id=bef05174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef05174",
  null
  
)

export default component.exports